import { ButtonHTMLAttributes, DetailedHTMLProps, forwardRef } from 'react'
import Button from '../Button/Button'
import css from './iconButton.module.css'

interface IProps extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  theme?: 'primary' | 'grey' | 'danger' | 'grey-outline' | 'lightgreen'
  loading?: boolean
}

export type TButtonProps = IProps

const IconButton = forwardRef<HTMLButtonElement, TButtonProps>((props, ref) => {
  return (
    <Button className={css.iconButton} {...props} ref={ref}/>
  )
})

export default IconButton
